import styled from "styled-components";

export const Styles = styled.div`
  .signin {
    padding: 0 15px;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
  .person-section {
    display: none;
  }
  .person-section-image {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    overflow: hidden;
    max-height: 40vh;
    padding-top: 40px;
    margin-top: 20px;
  }
  .person-section-image img {
    width: 90%;
    height: 90%;
    object-fit: contain;
    object-position: center;
    max-height: 90%;
  }
  .main-section {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    padding-top: 20px;
  }
  .main-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 400px;
    padding: 20px;
  }
  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  h2 {
    text-align: center;
    font-size: 20px;
    font-weight: 400;
    font-family: "MS_SemiBold";
  }
  p {
    text-align: center;
    color: ${({ colors }) => colors.color.darkGrey};
  }
  .agree {
    font-size: 11px;
    padding: 15px 0;
    border-bottom: 1px solid ${({ colors }) => colors.color.lightGrey};
  }
  button {
    padding: 8px 3px;
    font-size: 15px;
    border: none;
    border-radius: 5px;
    color: #fff;
    margin-top: 15px;
    width: 100%;
  }
  button:nth-of-type(2) {
    margin-bottom: 15px;
  }
  input {
    height: 35px;
    outline: none;
    border: 1.6px solid ${({ colors }) => colors.color.lightGrey};
    border-radius: 7px;
    padding: 15px 10px;
    font-size: 12px;
  }
  .github-btn {
    background-color: ${({ colors }) => colors.color.facebook};
  }
  .google-btn {
    background-color: ${({ colors }) => colors.color.google};
    // box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    padding: 3px 3px;
    border: none;
    border-radius: 5px;
    margin-top: 15px;
    width: 100%;
    cursor: pointer;
  }
  .google-text {
    color: ${({ colors }) => colors.color.white};
    text-align: center;
    font-size: 17px !important;
    margin-left: -3px;
  }
  .google-icon-wrapper {
    background-color: ${({ colors }) => colors.color.white};
    border-radius: 2px;
    padding: 7px;
  }
  .google-icon {
    width: 25px;
    height: 25px;
  }
  .continue {
    background-color: ${({ colors }) => colors.color.secondary};
  }
  .member {
    color: ${({ colors }) => colors.color.black};
    margin-top: 15px;
  }
  span {
    color: ${({ colors }) => colors.color.secondary};
    cursor: pointer;
  }
  .forget-password {
    text-align: end;
    font-size: 11px !important;
    color: ${({ colors }) => colors.color.google};
    margin: 5px;
    cursor: pointer;
  }
  .forget-password:hover {
    text-decoration: underline;
  }

  @media only screen and (min-width: 375px) {
    h2 {
      font-size: 25px;
    }
    p:last-child {
      font-size: 12.8px;
    }
    button {
      font-size: 15px;
    }
  }
  @media only screen and (min-width: 768px) {
    .signin {
      flex-direction: row;
      padding-right: 20px;
      padding-left: 0;
    }
    .person-section {
      display: block;
      width: 300px;
      flex: 0.8;
      max-height: 90vh;
      padding-top: 60px;
    }
    .person-section-image {
      max-height: 90vh;
      padding-top: 0;
      margin-top: 0;
    }
    @keyframes slideInLeft {
      0% {
        transform: translateX(-100%);
      }
      100% {
        transform: translateX(0);
      }
    }
    .person-section img {
      height: 90%;
      max-height: 90vh;
      animation: 1s ease-out 0s 1 slideInLeft;
    }
    .main-section {
      flex: 2;
    }
  }
  @media only screen and (min-height: 1024px) {
    .person-section {
      display: none;
    }
  }
  @media only screen and (min-width: 1024px) {
    .signin {
      padding: 0 50px;
    }
    .person-section {
      display: block;
      flex: 1;
    }
    .main-section {
      flex: 1;
    }
    .main-content {
      max-width: 450px;
    }
  }
`;
